import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const logoPath = "/assets/bimcubes-entry-logo.png";

export default function EntryLandingPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top,_rgba(190,242,100,0.12),_transparent_28%),linear-gradient(180deg,_#fbfdf8_0%,_#f8fcf3_44%,_#ffffff_100%)]" data-testid="entry-landing-page">
      <div className="absolute inset-0 pointer-events-none">
        <motion.div animate={{ opacity: [0.18, 0.32, 0.18], scale: [1, 1.04, 1] }} className="absolute left-1/2 top-[24%] h-64 w-64 -translate-x-1/2 rounded-full bg-[#99f6e4]/20 blur-3xl" transition={{ duration: 8, ease: "easeInOut", repeat: Infinity }} />
        <motion.div animate={{ opacity: [0.14, 0.26, 0.14], scale: [1, 1.06, 1] }} className="absolute left-1/2 top-[30%] h-80 w-80 -translate-x-1/2 rounded-full border border-[#d9f99d]/40" transition={{ duration: 11, ease: "easeInOut", repeat: Infinity }} />
        <motion.div animate={{ opacity: [0.2, 0.45, 0.2] }} className="absolute left-[28%] top-[32%] h-px w-28 bg-gradient-to-r from-transparent via-[#0f766e]/30 to-transparent" transition={{ duration: 6, ease: "easeInOut", repeat: Infinity }} />
        <motion.div animate={{ opacity: [0.2, 0.45, 0.2] }} className="absolute right-[28%] top-[32%] h-px w-28 bg-gradient-to-r from-transparent via-[#0f766e]/30 to-transparent" transition={{ duration: 6, ease: "easeInOut", repeat: Infinity, delay: 1.2 }} />
      </div>

      <div className="mx-auto flex min-h-screen max-w-5xl flex-col items-center justify-center px-6 text-center">
        <motion.div animate={{ opacity: 1, y: 0 }} initial={{ opacity: 0, y: 18 }} transition={{ duration: 0.8, ease: "easeOut" }}>
          <img alt="Bimcubes" className="mx-auto h-auto w-[min(82vw,34rem)] object-contain" data-testid="entry-logo-image" src={logoPath} />
          <p className="mt-6 text-sm uppercase tracking-[0.28em] text-[#0f766e]/70" data-testid="entry-subtitle">
            Choisissez votre mode d’accès
          </p>
        </motion.div>

        <motion.div animate={{ opacity: 1, y: 0 }} className="mt-10 flex flex-col gap-4 sm:flex-row" initial={{ opacity: 0, y: 18 }} transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}>
          <Button asChild className="h-12 rounded-full bg-[#0f766e] px-8 text-base text-white shadow-[0_24px_50px_-28px_rgba(15,118,110,0.55)] hover:bg-[#149289]">
            <Link data-testid="entry-visitor-button" to="/site">Visiteur</Link>
          </Button>
          <Button asChild className="h-12 rounded-full bg-slate-950 px-8 text-base text-white shadow-[0_24px_50px_-28px_rgba(15,23,42,0.45)] hover:bg-slate-800">
            <Link data-testid="entry-management-button" to="/management">Management</Link>
          </Button>
          <Button asChild className="h-12 rounded-full border-[#d8ece4] bg-white/90 px-8 text-base text-[#0f766e] shadow-[0_18px_40px_-30px_rgba(15,118,110,0.3)] hover:bg-[#ecfdf5] hover:text-[#0f766e]" variant="outline">
            <Link data-testid="entry-admin-button" to="/admin/login">Admin</Link>
          </Button>
        </motion.div>
      </div>
    </div>
  );
}